import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {IHistoryPaginatorViewModel} from "./history-paginator-view-model.interface";
import {action, observable, makeObservable, runInAction} from "mobx";
import {IHistoryRecordViewModel} from "../record/history-record-view-model.interface";
import {HistoryController_GetMigratedHistoryRequest} from "../../../api/api.service";
import {MigratedGamingHistoryRecordRawData} from "../../gaming-history.service.interfce";
import {MigratedGamingHistoryRecordModel} from "../record/migrated-gaming-history-record.model";

export class MigratedGamingHistoryPaginatorModel implements IHistoryPaginatorViewModel {

    constructor(protected readonly services: IServiceFactoryExtended) {
        makeObservable(this);
    }

    get daysIntervals(): number[] {
        return [30, 60, 90];
    }

    private _numberOfHistoryDays: number = 30;
    @action.bound
    setNumberOfHistoryDays(numberOfDays: number): void {
        this._numberOfHistoryDays = numberOfDays;
        this.records = []
        this._hasMoreRecords = true;
        this.isLoading = false
    }

    @observable.ref
    isLoading: boolean = false;

    @action.bound
    private _setIsLoading(value: boolean): void {
        this.isLoading = value;
    }

    @observable.ref
    private _hasMoreRecords: boolean = true;
    get hasMoreRecords(): boolean {
        return this._hasMoreRecords;
    }

    @observable.ref
    records: IHistoryRecordViewModel[] = [];

    async loadNextPage(): Promise<void> {
        if (this.isLoading) {
            return;
        }

        this._setIsLoading(true);

        const newRecords: IHistoryRecordViewModel[] = [];

        try {
            const serverResponse = await this.services.api.historyController.getMigratedHistory(this._createMigratedRequest());

            for (let recordData of serverResponse.GameHistoryData) {
                newRecords.push(this._createRecordModel(recordData));
            }

            runInAction(() => {
                this.records = [
                    ...this.records,
                    ...newRecords
                ];
            });
        } catch (err) {
            this.services.logger.error(`Failed to retrieve migrated history`, err);
        } finally {
            runInAction(() =>
                this._hasMoreRecords = false
            )
            this._setIsLoading(false);
        }
    }

    private _createMigratedRequest(): HistoryController_GetMigratedHistoryRequest {
        return {
            offset: 1,
            limit: 1,
            fromLastDays: this._numberOfHistoryDays,
        };
    }

    protected _createRecordModel(recordData: MigratedGamingHistoryRecordRawData): IHistoryRecordViewModel {
        return new MigratedGamingHistoryRecordModel(this.services, recordData);
    }
}